export default __webpack_public_path__ + "static/media/1.7b6c8598.jpg";